import {useContext, useRef, useState} from "react"
import styles from "./VoiceCallPanel.module.css"
import {VoiceCallContext} from "context/VoiceCallContext"
import Draggable from "react-draggable"
import {VoiceCallStudentPanel} from "../VoiceCallStudentPanel"
import {Settings} from "types/settings"
import {useModel, useVisible} from "hooks"
import AddContactForm from "sections/users/Detail/parts/Contacts/parts/AddContactForm"

export function VoiceCallPanel() {
    const {calling, activeStudent, queuedStudents, voiceProvider} = useContext(VoiceCallContext)
    const model = useModel()
    const disabledPanel = model.slug === "nau" && voiceProvider === Settings.DialerProvider.Zoom
    const [contactPhone, setContactPhone] = useState<string | null>(null)
    const showAddContact = useVisible(false)

    const containerRef = useRef<HTMLDivElement>(null)
    const callVisible = !((queuedStudents.length === 0 && !calling) || !activeStudent || disabledPanel)

    const openAddContact = (phone: string) => {
        setContactPhone(phone)
        showAddContact.open()
    }

    const closeAddContact = () => {
        showAddContact.close()
        setContactPhone(null)
    }

    if (!callVisible && !showAddContact.isVisible) return null

    return (
        <>
            {callVisible && (
                <Draggable bounds="parent" nodeRef={containerRef}>
                    <div ref={containerRef} className={styles.containerWrap}>
                        <VoiceCallStudentPanel onAddContact={openAddContact} />
                    </div>
                </Draggable>
            )}
            {showAddContact.isVisible && contactPhone && (
                <AddContactForm isShow onClose={closeAddContact} data={{phone: contactPhone}} selectRelatedStudent />
            )}
        </>
    )
}
